__turbopack_context__.v({
  "addressCell": "AccountsPage-module__uJmjiq__addressCell",
  "addressIcon": "AccountsPage-module__uJmjiq__addressIcon",
  "balance": "AccountsPage-module__uJmjiq__balance",
  "contractBadge": "AccountsPage-module__uJmjiq__contractBadge",
  "emptyState": "AccountsPage-module__uJmjiq__emptyState",
  "header": "AccountsPage-module__uJmjiq__header",
  "link": "AccountsPage-module__uJmjiq__link",
  "loading": "AccountsPage-module__uJmjiq__loading",
  "notVerified": "AccountsPage-module__uJmjiq__notVerified",
  "pageButton": "AccountsPage-module__uJmjiq__pageButton",
  "pageButtonActive": "AccountsPage-module__uJmjiq__pageButtonActive",
  "pagination": "AccountsPage-module__uJmjiq__pagination",
  "percentage": "AccountsPage-module__uJmjiq__percentage",
  "rank": "AccountsPage-module__uJmjiq__rank",
  "shimmer": "AccountsPage-module__uJmjiq__shimmer",
  "skeleton": "AccountsPage-module__uJmjiq__skeleton",
  "table": "AccountsPage-module__uJmjiq__table",
  "tableContainer": "AccountsPage-module__uJmjiq__tableContainer",
  "title": "AccountsPage-module__uJmjiq__title",
  "txCount": "AccountsPage-module__uJmjiq__txCount",
});
